var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { HDSProgressIndicator } from "@here/hds-react-components/ProgressIndicator";
import { HDSButton } from "@here/hds-react-components/Button";
import { postConfigurationDetails } from "../../api/venues";
import translations from "../../translations/resources/en-GB.json";
import { useDispatch, useSelector } from "react-redux";
import { setCollectionHRNs, setIndoorCatalogHrn, setIsLoaded, setIsRealmSetup, } from "../../store/reducers/appSlice";
import "./noRealmSetup.scss";
import { toast } from "@here/hds-notification";
import { ModalPortal } from "../../components/mapModal/ModalPortal";
import { ERROR_STATUS_REALM_SETUP } from "./constants";
import { setTokenScopeToProject } from "../../api/account";
import { ConfirmDailog } from "../../generic-components";
var NoRealmSetup = function () {
    var dispatch = useDispatch();
    var userToken = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.userToken; });
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var postConfiguration = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var res, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShowModal(true);
                    //for HDS version "@here/hds-react-components": "^2022.8.0", onclick event of HDSButton fires multiple calls
                    //for prevention belove fix done
                    e.stopImmediatePropagation();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postConfigurationDetails(userToken)];
                case 2:
                    res = _b.sent();
                    if (res.status === 200) {
                        dispatch(setTokenScopeToProject(userToken));
                        dispatch(setIsRealmSetup(true));
                        dispatch(setIsLoaded(false));
                        dispatch(setIndoorCatalogHrn(res.data.mapsCatalogHrn));
                        dispatch(setCollectionHRNs(res.data.collectionCatalogHrns));
                        setShowModal(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    setShowModal(false);
                    if (ERROR_STATUS_REALM_SETUP[(_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.status]) {
                        toast({
                            title: translations.data["venonboard.realmSetup.notificationTitle"],
                            body: translations.data["venonboard.realmSetup.notificationMessage.noCreds"],
                            timeout: 6,
                            status: "error",
                        });
                    }
                    else {
                        toast({
                            title: translations.data["venonboard.realmSetup.notificationTitle"],
                            body: translations.data["venonboard.realmSetup.notificationMessageError"],
                            timeout: 6,
                            status: "error",
                        });
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx(ModalPortal, { children: showModal && (_jsx(ConfirmDailog, __assign({ hideCloseBtn: true, disableCloseOnOverlayClick: true, disableCloseOnEscape: true, header: "Realm Setup", 
                    //TODO: for current version of hds hideFooter is omitted for HDSConfirm
                    //once update to latest version, replace footer with hideFooter
                    footer: _jsx(_Fragment, {}) }, { children: _jsxs("div", __assign({ style: {
                            position: "relative",
                            textAlign: "center",
                            verticalAlign: "middle",
                        } }, { children: [_jsx(HDSProgressIndicator, { color: "accent", variant: "indeterminate", indicatorType: "linear" }), _jsx("p", __assign({ style: { paddingTop: "30px" } }, { children: translations.data["venonboard.newMapOrder.realmSetupMessage1"] })), _jsx("p", { children: translations.data["venonboard.newMapOrder.realmSetupMessage2"] })] })) }))) }), _jsx("div", __assign({ className: "realmSetupBox" }, { children: _jsxs("div", __assign({ className: "realmSetupContainer" }, { children: [_jsx("div", __assign({ className: "realmSetupHeadline" }, { children: translations.data["venonboard.realmSetup.notificationTitle"] })), _jsx(HDSButton, __assign({ variant: "primary", size: "large", width: "123px", onClick: postConfiguration }, { children: translations.data["venonboard.realmSetup.button"] }))] })) }))] }));
};
export default NoRealmSetup;
